module.exports = __webpack_public_path__ + "img/014_L.6dca0ca8.png";